import React from "react";
import PoolishCalculator from "./PoolishCalculator";

function App() {
  return (
    <div className="App">
      <PoolishCalculator />
    </div>
  );
}

export default App;
